import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function TimerButton({ onClick, children }) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const { t } = useTranslation();

  const handleClick = () => {
    const cooldown = 2;
    setIsDisabled(true);
    setSecondsLeft(cooldown);

    // Chiama la funzione passata come prop (es: fetchData)
    if (onClick) onClick();

    const countdown = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(countdown);
          setIsDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <button
        className={"btn btn-primary updateList mt-2 mb-4"}
        onClick={handleClick}
        disabled={isDisabled}
      >
        {isDisabled ? (
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
            <i className="bi bi-arrow-repeat spin"></i>
            <span>{secondsLeft}</span>
          </span>
        ) : children}
      </button>
    </div>
  );
}

export default TimerButton;
